import React from 'react';

const ReissuReservation = ({ num, data, handleChange }) => {
    return (
        <table
            className='table_style4 bdt mb70'
            cellPadding='0'
            cellSpacing='0'
            id='airCertInfoTbl'
            id-data={num}
        >
            <colgroup>
                <col style={{ width: '190px' }} />
                <col style={{ width: '410px' }} />
                <col style={{ width: '190px' }} />
                <col style={{ width: 'auto' }} />
            </colgroup>
            <tbody>
                <tr>
                    <th>
                        <p className='essential'>항공사 예약번호</p>
                    </th>
                    <td>
                        <input
                            type='text'
                            onChange={(e) => handleChange(num, 'air_pnr', e.target.value.replace(/[\u3131-\u318F\uAC00-\uD7A3]/g, '').toUpperCase())}
                            value={data.air_pnr}
                            style={{ width: '370px' }}
                        />
                    </td>
                    <th>
                        <p class='essential'>탑승객명</p>
                    </th>
                    <td>
                        <input
                            type='text'
                            value={data.tkt_number}
                            onChange={(e) => handleChange(num, 'tkt_number', e.target.value)}
                            style={{ width: '370px' }}
                        />
                    </td>
                </tr>
                <tr>
                    <th>
                        <p className='essential'>ORIGIN 티켓번호</p>
                    </th>
                    <td>
                        <input
                            type='text'
                            value={data.org_flight}
                            onChange={(e) => handleChange(num, 'org_flight', e.target.value.replace(/[A-Za-zㄱ-힣]/g, ''))}
                            style={{ width: '370px' }}
                        />
                    </td>
                    <th>
                        <p class='essential'>VOID 요청 티켓번호</p>
                    </th>
                    <td>
                        <input
                            type='text'
                            value={data.new_flight}
                            onChange={(e) => handleChange(num, 'new_flight', e.target.value.replace(/[A-Za-zㄱ-힣]/g, ''))}
                            style={{ width: '370px' }}
                        />
                    </td>
                </tr>
                <tr>
                    <th>
                        <p className='essential'>S/C 영향 편명 및 일자</p>
                    </th>
                    <td colSpan={3}>
                        <input
                            type='text'
                            value={data.tkt_email_address}
                            onChange={(e) => handleChange(num, 'tkt_email_address', e.target.value)}
                            style={{ width: '100%' }}
                            placeholder='예) PR2975/31MAR'
                        />
                    </td>
                </tr>
                <tr>
                    <th>
                        <p>&nbsp;&nbsp;&nbsp;&nbsp;비고</p>
                    </th>
                    <td colSpan={3}>
                        <textarea
                            name='PaxBirthday'
                            id='remark'
                            class='remarkInput'
                            value={data.freeMemo}
                            onChange={(e) => handleChange(num, 'freeMemo', e.target.value)}
                        />
                    </td>
                </tr>
            </tbody>
            <p className='pointText fontWeight'>
                * 동일 PNR에 티켓 번호가 여러 개인 경우, 한번에 요청해 주시기 바랍니다.(예. 079
                987651110/11/12/13)
            </p>
        </table>
    );
};

export default ReissuReservation;
